export default __webpack_public_path__ + "static/media/Boots of Ardent Fire.eff4059a.jpg";